const styles = theme => ({
wow:{
  lineHeight: '20px!important',
}
})

export default styles
